export class Country{
    uid: string;
    name: string;
    index = 0;
}
